module.exports = __webpack_public_path__ + "img/Japan-Racing-Wheels-NB.32d843f6.jpg";